<template>
  <div class="form">
    <div class="form-ipt">
      <input v-model="form.search" class="search-ipt" placeholder="智能搜索" type="text" @keyup.13="handleQuery" />
      <a-icon class="search" type="search" />
    </div>

    <a-form-model ref="form" :labelCol="{ span: 6 }" :model="form" class="form-ant" labelAlign="right">
      <a-row>
        <a-col span="6">
          <a-form-model-item label="区域">
            <a-select
              v-model="form.districtIdList"
              mode="multiple"
              option-filter-prop="children"
              placeholder="请选择"
              show-search
              @change="regionChange"
            >
              <a-select-option v-for="item in districtList" :key="item.areaId" :value="item.areaId">
                {{ item.areaName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item label="商圈">
            <a-select
              v-model="form.businessDistrictIdList"
              mode="multiple"
              option-filter-prop="children"
              placeholder="请选择"
              show-search
              @change="businessDistrictMethod"
            >
              <a-select-option v-for="item in businessDistrictList" :key="item.id" :value="item.id">{{ item.businessDistrictName }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item label="街道">
            <a-select v-model="form.streetIdList" mode="multiple" option-filter-prop="children" placeholder="请选择" show-search>
              <a-select-option v-for="item in streetList" :key="item.id" :value="item.id">{{ item.streetFullName }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item label="商铺类型">
            <a-select v-model="form.shopType" placeholder="请选择">
              <a-select-option v-for="item in typeOptions" :key="item.dictValue" :value="item.dictValue">
                {{ item.dictLabel }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col span="6">
          <a-form-model-item label="面积" prop="requirementAreaStart">
            <a-input
              v-model="form.requirementAreaStart"
              :maxLength="5"
              class="area-ipt"
              placeholder="开始"
              type="text"
              @input="intValidate('requirementAreaStart')"
            />
            <span>-</span>
            <a-input
              v-model="form.requirementAreaEnd"
              :maxLength="5"
              class="area-ipt"
              placeholder="结束"
              type="text"
              @input="intValidate('requirementAreaEnd')"
            />
            m²
          </a-form-model-item>

          <!-- <a-form-model-item class="form-lable" label=" " :colon="false" prop="requirementAreaEnd">
              <a-input
                class="area-ipt"
                v-model="form.requirementAreaEnd"
                type="text"
                placeholder="结束"
                :maxLength="5"
                @input="intValidate('requirementAreaEnd')"
              />m²
            </a-form-model-item> -->
        </a-col>
        <a-col span="10">
          <span style="display: flex; align-items: center">
            <a-form-model-item label="租金" prop="rentExpenseStart">
              <a-input
                v-model="time.rentExpenseStart"
                :maxLength="7"
                class="area-ipt"
                placeholder="开始"
                type="text"
                @change="timeSwitching"
                @input="intValidate('rentExpenseStart')"
              />
              <span>-</span>
              <a-input
                v-model="time.rentExpenseEnd"
                :maxLength="7"
                class="area-ipt"
                placeholder="结束"
                type="text"
                @change="timeSwitching"
                @input="intValidate('rentExpenseEnd')"
              />
              <!-- <span style="display: flex; width: 36px">{{ flag === 1 ? '元/月' : flag === 0 ? '元/日' : '' }}</span> -->
              <a-select v-model="flag" placeholder="月租金" style="width: 90px; marginleft: 20px">
                <a-select-option :value="2">全部</a-select-option>
                <!-- <a-select-option :value="0"> 日租金</a-select-option> -->
                <a-select-option :value="1">月租金</a-select-option>
              </a-select>
            </a-form-model-item>
            <!-- <a-form-model-item class="form-lable" label=" " :colon="false">
              <span>-</span>
            </a-form-model-item>
            <a-form-model-item class="form-lable" label=" " :colon="false" prop="rentExpenseEnd">
              <a-input
                class="area-ipt"
                type="text"
                @change="timeSwitching"
                v-model="time.rentExpenseEnd"
                placeholder="结束"
                :maxLength="7"
                @input="intValidate('rentExpenseEnd')"
              />
              <a-select placeholder="月租金" v-model="flag" style="width: 90px;marginLeft:20px">
                <a-select-option :value="2"> 全部</a-select-option>
                <a-select-option :value="1"> 月租金</a-select-option>
              </a-select>
            </a-form-model-item> -->
          </span>
        </a-col>
        <a-col span="7">
          <span style="display: flex; align-items: center">
            <a-form-model-item label="楼层" prop="floorStart">
              <a-input
                v-model="form.floorStart"
                :maxLength="2"
                class="area-ipt"
                placeholder="开始"
                type="text"
                @input="intValidate('floorStart')" />
              <span>-</span>
              <a-input
                v-model="form.floorEnd"
                :maxLength="2"
                class="area-ipt"
                placeholder="结束"
                type="text"
                @input="intValidate('floorEnd')" />
              层
            </a-form-model-item>
            <!-- <a-form-model-item class="form-lable" label=" " :colon="false">
              <span>-</span>
            </a-form-model-item>
            <a-form-model-item class="form-lable" label=" " :colon="false" prop="floorEnd">
              <a-input
                v-model="form.floorEnd"
                class="area-ipt"
                type="text"
                placeholder="结束"
                :maxLength="2"
                @input="intValidate('floorEnd')"
              />层
            </a-form-model-item> -->
          </span>
        </a-col>
      </a-row>
      <a-row>
        <a-col span="8">
          <a-form-model-item label="维护人员">
            <div style="display: flex; align-items: center">
              <a-tree-select
                v-model="form.deptId"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :replaceFields="replaceFields"
                :tree-data="deptOptions"
                placeholder="部门"
                style="width: 150px"
                tree-default-expand-all
                @change="handleChangeTree"
              ></a-tree-select>
              <span>&nbsp;-&nbsp;</span>
              <a-select v-model="form.accendantId" placeholder="人员" style="width: 110px" @dropdownVisibleChange="handleOptiontourist($event)">
                <a-select-option v-for="item in userList" :key="item.userId" :value="item.userId">
                  {{ item.nickName }}
                </a-select-option>
              </a-select>
            </div>
          </a-form-model-item>
        </a-col>
        <a-col span="10">
          <a-form-model-item label="经营行业">
            <span style="display: flex; margin-top: 4px">
              <a-select
                v-model="form.industryCategoryId"
                :filter-option="filterOption"
                allowClear
                placeholder="行业大类"
                show-search
                style="margin-right: 3px"
                @change="industrySubclassFn"
              >
                <a-select-option v-for="item in industryCategory" :key="item.id" :value="item.id">{{ item.industryCategoryName }}</a-select-option>
              </a-select>
              <span>-&nbsp;</span>
              <a-select
                v-model="form.industrySubclassId"
                :filter-option="filterOption"
                allowClear
                placeholder="子类"
                show-search
                style="width: 150px"
              >
                <a-select-option v-for="item in industrySubclass" :key="item.id" :value="item.id">{{ item.industryCategoryName }}</a-select-option>
              </a-select>
            </span>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item label="日期">
            <a-select v-model="form.dateType" placeholder="全部">
              <a-select-option :value="0">全部</a-select-option>
              <a-select-option :value="1">跟进日期</a-select-option>
              <a-select-option :value="2">录入日期</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="6">
          <a-form-model-item label="盘别">
            <a-select v-model="form.dishTypeOpts" :allowClear="true" placeholder="请选择">
              <a-select-option v-for="item in dishTypeOpts" :key="item.dictValue" :value="item.dictValue">
                {{ item.dictLabel }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <div style="height: 64px">
            <a-form-model-item v-if="form.dateType" label="" style="display: flex; align-items: center">
              <div style="display: flex; align-items: center; width: 240px">
                <a-date-picker v-model="form.startTime" :disabled-date="disabledDate" placeholder="开始时间"></a-date-picker>
                <span>-</span>
                <a-date-picker v-model="form.endTime" :disabled-date="disabledDate" placeholder="结束时间"></a-date-picker>
              </div>
            </a-form-model-item>
            <a-form-model-item v-else label="" style="display: flex; align-items: center">
              <div style="width: 240px; opcity: 0">
                <span>&emsp;</span>
              </div>
            </a-form-model-item>
          </div>
        </a-col>
        <a-col span="6">
          <a-form-model-item label="成交">
            <a-select v-model="form.trades" :allowClear="true" placeholder="请选择">
              <a-select-option value="1">已成交</a-select-option>
              <a-select-option value="2">未成交</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item>
            <div style="margin-top: 1px">
              <a-button class="el_button el_button_b" @click="handleReset">重置</a-button>
              <a-button :style="{ marginLeft: '16px' }" class="search-btn" @click="handleQuery">查询</a-button>
              <a-button v-hasPermi="['tourist:rentTouristList:export']" style="margin-left: 20px" type="primary" @click="export_touristList">
                <a-icon type="download" />
                导出
              </a-button>
              <a-button type="primary" @click="exportClientAnalyze" style="margin-left: 20px;">
                <a-icon type="download" />
                导出客源分析
              </a-button>
            </div>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </div>
</template>

<script>
import { treeSelectMixin } from '@/mixin/treeSelect'
import { locationSelectMixin } from '@/mixin/locationSelect'
import moment from 'moment'

export default {
  mixins: [treeSelectMixin, locationSelectMixin],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    time: {
      type: Object,
      default: () => ({})
    },
    typeOptions: {
      type: Array,
      default: () => []
    },
    dishTypeOpts: {
      type: Array,
      default: () => []
    },
    // userList:{
    //     type:Array,
    //     default:() => []
    // },
    industryCategory: {
      type: Array,
      default: () => []
    },
    industrySubclass: {
      type: Array,
      default: () => []
    },
    flag: {
      type: [Number, String],
      default: ''
    }
  },
  watch: {
    form: {
      handler () {},
      deep: true,
      immediate: true
    },
    time: {
      handler () {},
      deep: true,
      immediate: true
    },
    typeOptions: {
      handler () {},
      deep: true,
      immediate: true
    },
    userList: {
      handler () {},
      deep: true,
      immediate: true
    },
    industryCategory: {
      handler () {},
      deep: true,
      immediate: true
    },
    industrySubclass: {
      handler () {},
      deep: true,
      immediate: true
    }
  },
  data () {
    return {}
  },
  methods: {
    disabledDate (current) {
      return current && current > moment().endOf('day')
    },
    handleQuery () {
      this.$emit('handleQuery')
    },
    industrySubclassFn (val) {
      this.$emit('industrySubclassFn', val)
    },
    intValidate (item) {
      this.$emit('intValidate', item)
    },
    timeSwitching (item) {
      this.$emit('timeSwitching', item)
    },
    handleReset (item) {
      this.$emit('handleReset', item)
    },
    export_touristList (item) {
      this.$emit('export_touristList', item)
    },
    filterOption (input, option) {
      // console.log(option,'option')
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    exportClientAnalyze () {
      const that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出个人上架客源的所有数据',
        onOk () {
          try {
            that.downloadPost(
              '/lesseeRequirement/exportClientAnalyze',
              that.form,
              `客源分析_${new Date().getTime()}.xlsx`
            )
          } catch (e) {
          }
        },
        onCancel () {
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.form {
  padding: 0 20px;
  background-color: white;

  .form-ipt {
    position: relative;
    margin-bottom: 20px;

    .search-ipt {
      // width: 50%;
      height: 36px;
      border-radius: 20px;
      outline: none;
      border: 1px solid rgb(236, 236, 236);
      padding-left: 50px;
      width: 300px;
      border-radius: 30px;
    }

    .search {
      font-size: 22px;
      position: absolute;
      left: 20px;
      top: 10px;
    }
  }

  .form-ant {
    // display: flex;
    // justify-content: space-between;
    .col-two {
      .form-lable {
        /deep/ .ant-form-item-label {
          width: 0px;
        }
      }
    }

    .area-ipt {
      width: 80px;
    }

    .floor-ipt {
      width: 60px;
    }

    .ant-form-item {
      display: flex;
      align-items: center;

      /deep/ .ant-form-item-children {
        display: flex;
        align-items: center;
      }

      .rzj {
        width: 60px;
        display: inline-block;
        background-color: #c0c0c0;
        height: 20px;
        line-height: 20px;
        font-size: 6px;
        padding-left: 5px;
        padding-right: 5px;
        text-align: center;
        cursor: pointer;
      }

      .isflag {
        border: 1px solid var(--ThemeColor);
        color: var(--ThemeColor);
        background-color: #fef7f1;
      }

      .el_button_b {
        width: 62px;
      }

      .search-btn {
        background-color: var(--ThemeColor);
        color: white;
      }
    }

    .flex {
      display: flex;
      align-items: center;
      line-height: 26px;
    }

    /deep/ .ant-select {
      width: 150px;
    }
  }
}
</style>
